export default __webpack_public_path__ + "static/accents-avoid-yellow-do-light-8b068baffc707410da6a8517f5f7a400190b4876be291edab85c818731e6f83f.png";